module.exports = __webpack_public_path__ + "static/media/navbar-messenger-pro.7163548d.svg";